// extracted by mini-css-extract-plugin
export default {"answersCountContainer":"TaskAnswerCount_answersCountContainer__ZQPhJ"};